import { useGetOrgContractDocumentEvents, useInsertOrgContractDocumentEvent } from '@/graphql';

export const useGetContractDocumentEvents = (contractDocumentId: string, enabled = true) => {
  const query = useGetOrgContractDocumentEvents(
    {
      where: { ContractDocumentId: { eq: contractDocumentId } },
      order: { direction: 'DESC', field: 'OccurredAt' },
      paging: { pageNo: 1, pageSize: 200 },
    },
    { enabled: Boolean(contractDocumentId) && enabled }
  );

  const page = query.data?.getOrgContractDocumentEvents;

  return {
    ...query,
    data: page ? { items: page.items ?? [], totalCount: page.totalCount ?? 0 } : undefined,
  };
};

export const useCreateContractDocumentEvent = () => useInsertOrgContractDocumentEvent();
